import {
  AfterViewInit,
  Component,
  inject,
  input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { EmployeeDisability } from '@qaroni-app/employee/types/employee-disability';
import { PanelProfileService } from '@qaroni-app/panel-profile/services/panel-profile.service';
import { EmployeeDisabilitiesDataSource } from '@qaroni-app/panel-profile/types/employee-disabilities-datasource';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

//TODO: Todvía no cambiar el nombre del selector por el correcto
@Component({
  selector: 'qaroni-employee-disabilities-tables',
  templateUrl: './employee-disabilities-table.component.html',
  styleUrls: ['./employee-disabilities-table.component.scss'],
  standalone: false,
})
export class EmployeeDisabilitiesTableComponent
  implements OnInit, AfterViewInit
{
  readonly employeeID = input<number>(0);
  readonly showPaginator = input<boolean>(true);

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatTable) table!: MatTable<EmployeeDisability>;

  private panelProfileService = inject(PanelProfileService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  public dataSource: EmployeeDisabilitiesDataSource | null = null;

  public displayedColumns: string[] = [
    'name',
    'degree',
    'isPermanent',
    'expirationDate',
    'actions',
  ];

  public employeeDisabilities$: Observable<EmployeeDisability[]> =
    this.panelProfileService.getEmployeeDisabilities$().pipe(shareReplay(1));

  ngOnInit(): void {
    const employeeID = this.employeeID();
    if (Number.isInteger(employeeID)) {
      this.dataSource = new EmployeeDisabilitiesDataSource(
        this.route,
        this.router,
        this.panelProfileService,
        employeeID
      );
    }
  }

  ngAfterViewInit(): void {
    if (!this.dataSource) {
      return;
    }
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.table.dataSource = this.dataSource;
  }

  get hasDisabilities(): boolean {
    return this.paginator?.length ? true : false;
  }
}
